import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../store';
import { setFetchingEnseignants, setFilteredEnseignants, setdataFiltered } from '../../store/focusEcoleSlice';
import { Box } from '@mui/material';
import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";

export interface ISearchYearProps {
    currentYear: any
    setCurrentYear: (x: any) => void;
    localArraySouscripteur: any;
    setLocalArraySouscripteur: (x: any) => void;
}


export default function SearchYear(props: ISearchYearProps) {
    const { localArraySouscripteur, setLocalArraySouscripteur, currentYear, setCurrentYear } = props

    const dispatch = useDispatch();
    const { anneesScolairesSouscription } = useSelector((state: IReduxState) => state.focusEcole);



    return (
        <Box>
            <Autocomplete
                fullWidth
                onChange={(e: any, annee: any) => {
                    if (annee) {
                        setCurrentYear({
                            ...currentYear,
                            anneescolaire: annee.anScol
                        });
                    }
                    else {
                        setCurrentYear({})
                        setLocalArraySouscripteur([...localArraySouscripteur])
                    }
                }}
                options={anneesScolairesSouscription}
                renderOption={(props, annee) => {
                    const { anScol } = annee;
                    const newIndex = anneesScolairesSouscription.findIndex((item: any) => item.anScol === anScol)
                    return (
                        <span {...props}
                            style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                        >
                            {anScol}
                        </span>
                    );
                }}

                getOptionLabel={(annee) =>
                    `${annee.anScol}`
                }

                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Choisir une année..."
                    />
                )}
            />
        </Box>
    );
}
